'use client'
import {useTranslations} from "next-intl";
import {Flex, Typography, Row, Col, Layout, ConfigProvider, Spin, Divider} from "antd";
import {Content} from "antd/lib/layout/layout";
import React, {CSSProperties, useEffect, useState} from "react";
import '@/src/app/[locale]/home/home.css';
import SanitazeHTML from "@/src/components/sanitazeHTML";
import './privacy.css';
import {inter} from "@/src/app/fonts";
import {Constants} from "@/src/lib/constants";
import {ThemeService} from "@/src/services/theme";
import dynamic from "next/dynamic";
import LoaderComponent from "@/src/components/loader";
import {LoadingOutlined} from "@ant-design/icons";
import Loading from "../loading";
import {LoggerService} from "@/src/services/logger";

const PrivacyPage = () => {
    const localization = useTranslations('privacyAndCookies');
    const themeColors = ThemeService.getThemeColors()
    const [isLoaded, setIsLoaded] = useState(false)

    useEffect(() => {
        LoggerService.getLogger().debug("<<< ENTER INTO PRIVACY")
        setIsLoaded(true)
    }, []);

    const titleStyle: CSSProperties = {
        marginTop: 40,
        marginBottom: 10
    }

    const getPrivacyText = () => {
        const txt: string = localization.raw("privacy.text")
            .replace("_privacy_owner_text", `
            <p class="privacy"><b class="privacy">${Constants.privacyManagerName}</b></p>
            <p class="privacy">${Constants.privacyManagerAddressRow1}</p>
            <p class="privacy">${Constants.privacyManagerAddressRow2}</p>
            <p class="privacy"><b class="privacy">${localization("privacy.owner.mobile")}: </b>${Constants.privacyManagerPhone}</p>
            <p class="privacy"><b class="privacy">${localization("privacy.owner.email")}: </b>${Constants.privacyManagerEmail}</p>
            <p class="privacy"><b class="privacy">${localization("privacy.owner.vat")}: </b>${Constants.privacyManagerVat}</p>
        `)
        return txt
    }

    const Sanitize = dynamic(() => import('@/src/components/sanitazeHTML'), {
        ssr: false,
        loading: () =>  <Loading />

    });

    return <Layout>
        <Content style={{ padding: "0 16px 48px 16px", backgroundColor: `${themeColors.tertiary}` }}>
            <Row gutter={16}>
                <Col xs={24} md={12}>
                    <Flex vertical gap={16} className={inter.className}>
                        <Typography.Title level={3} style={titleStyle}>{localization("privacy.title")}</Typography.Title>
                        <Divider style={{marginTop: 0}} />
                        <Sanitize html={getPrivacyText()} options={{ALLOWED_TAGS: ["p", "h1", "h2", "ul", "li", "b", "privacyOwner"], ALLOWED_ATTR: ["class"]}}></Sanitize>
                    </Flex>
                </Col>

                <Col xs={24} md={12}>
                    <Flex vertical gap={16} className={inter.className}>
                        <Typography.Title level={3} style={titleStyle}>{localization("cookies.title")}</Typography.Title>
                        <Divider style={{marginTop: 0}} />
                        <Sanitize html={localization.raw("cookies.text")} options={{ALLOWED_TAGS: ["p", "h1", "h2", "ul", "li", "b"], ALLOWED_ATTR: ["class"]}}></Sanitize>
                    </Flex>
                </Col>
            </Row>
        </Content>

    </Layout>
}

export default PrivacyPage

